import { render, staticRenderFns } from "./HiddenPackage.vue?vue&type=template&id=495c259b&scoped=true&"
import script from "./HiddenPackage.vue?vue&type=script&lang=js&"
export * from "./HiddenPackage.vue?vue&type=script&lang=js&"
import style0 from "./HiddenPackage.vue?vue&type=style&index=0&id=495c259b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c259b",
  null
  
)

export default component.exports